/** Sales catalogue / deal proposals (KPI, deal invoice won flow, Cleo retail). */
export const RETAIL_PROPOSAL_SOURCE = "retail_proposal";

/** Multi-line / project-backed proposals (spreadsheet confirm-upload, project revisions). */
export const PROJECT_PROPOSAL_SOURCE = "project_proposal";

/** Staff-entered commercial metadata with PDF attachment only (no parser / KPI pipeline). */
export const MANUAL_PDF_UPLOAD_SOURCE = "manual_pdf_upload";

/** D-Tools SI JSON sandbox confirm → project-backed proposal (no PDF wrapper). */
export const DTOOLS_JSON_PROPOSAL_SOURCE = "dtools_json";

/** Normalise for comparisons: blank/NULL → retail (legacy rows). */
export function normalisedProposalSource(value: string | null | undefined): string {
  const t = String(value ?? "").trim();
  return t === "" ? RETAIL_PROPOSAL_SOURCE : t;
}

export function isRetailProposalSourceValue(value: string | null | undefined): boolean {
  return normalisedProposalSource(value) === RETAIL_PROPOSAL_SOURCE;
}

export function isProjectProposalSourceValue(value: string | null | undefined): boolean {
  return normalisedProposalSource(value) === PROJECT_PROPOSAL_SOURCE;
}

export function isManualPdfUploadProposalSourceValue(value: string | null | undefined): boolean {
  return normalisedProposalSource(value) === MANUAL_PDF_UPLOAD_SOURCE;
}

export function isDtoolsJsonProposalSourceValue(value: string | null | undefined): boolean {
  return normalisedProposalSource(value) === DTOOLS_JSON_PROPOSAL_SOURCE;
}

/** Project spreadsheet / upload confirm and D-Tools JSON import (multi-line, project lineage). */
export function isProjectBackedProposalSourceValue(value: string | null | undefined): boolean {
  const s = normalisedProposalSource(value);
  return s === PROJECT_PROPOSAL_SOURCE || s === DTOOLS_JSON_PROPOSAL_SOURCE;
}

/** Staff Sales portal surfaces (lists, deal workspace, Cleo) — includes D-Tools JSON imports. */
export function isStaffSalesPortalProposalSourceValue(value: string | null | undefined): boolean {
  return (
    isRetailProposalSourceValue(value) ||
    isProjectProposalSourceValue(value) ||
    isManualPdfUploadProposalSourceValue(value) ||
    isDtoolsJsonProposalSourceValue(value)
  );
}
